import React from "react";

const NoResultsCard = ({ children }: { children: React.ReactNode }) => (
  <div className="p-3 font-weight-bold text-center bg-white rounded">
    {children}
  </div>
);

export default NoResultsCard;
